
  export default {
    data () {
      return {
        brands: {
          Facebook: 'bonkers.ie',
          Twitter: 'bonkers_ie',
          YouTube: 'channel/UCZ85UhK5tgU2OzXWin81GWA',
          Instagram: 'bonkers.ie',
          LinkedIn: 'company/2129065',
          TikTok: '@bonkers.ie'
        }
      };
    }
  };
